import { Component, OnInit, Inject, Output, EventEmitter, Input, ElementRef, AfterViewInit, ViewChild, DOCUMENT } from '@angular/core';

import { Router, RouterEvent, NavigationStart } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import notify from 'devextreme/ui/notify';




@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    standalone: false
})

export class NotificationComponent implements OnInit {

  onInitialized = new EventEmitter<NotificationComponent>();

  @Input()
  __sNotificationMessage: string = ''
  @Input()
  __bIsPasswordExpiryNotification: boolean = false;
  @Output() childEvent = new EventEmitter();


  //Constructor
  constructor(@Inject(DOCUMENT) private document: any, private router: Router) {

  }

  // fires on post view renders
  ngAfterViewInit(): void { }

  // fires on initialization
  ngOnInit() {
    this.onInitialized.emit(this);
  }


  
  OpenChangePasswordPopUp() {
    this.childEvent.emit();
  }

}
